import { css } from '@emotion/core';
import { tokens, media } from '@domain-group/fe-brary';
import { designTokenFonts } from '@domain-group/fe-co-allhomes-design-system';
var colors = tokens.colors;
export var simpleStat = /*#__PURE__*/css("border-radius:10px;border:1px solid ", colors.neutral.trim.default, ";padding:20px 24px;display:flex;flex-direction:column;align-items:center;gap:8px;width:100%;color:", colors.neutral.heavy.default, ";", media('>=tablet'), "{width:160px;}");
export var label = /*#__PURE__*/css(designTokenFonts.body);
export var value = /*#__PURE__*/css(designTokenFonts.heading);